<div class="container-fluid lightPurpleGradientBg">
  <div class="row">
    <div class="col-md-12 mt-5 pt-5">
      <div class="container-fluid customGapping mt-5 pb-5">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-10 mt-4">
            <div class="row">
              <div class="col-md-12">
                <a href="#"
                  ><img
                    src="../../../../assets/instaciti-new-img/instaciti_beta 1.svg"
                    class="img-fluid"
                    alt="instaciti-img"
                /></a>
              </div>
              <div class="col-md-12 mt-3">
                <p class="mb-0 font-12 darkMuted">
                  InstaCiti helps SMEs develop an online presence and create
                  their very own branding experience.
                </p>
              </div>
              <div class="col-md-12 mt-4 d-flex textDecorationNone">
                <div class="socialIcon me-3">
                  <a
                    href="https://www.facebook.com/instacitiwow"
                    target="_blank"
                  >
                    <img
                      src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/icons/facebook-icon.svg"
                      class=""
                      alt="facebook"
                    />
                  </a>
                </div>
                <div class="socialIcon me-3">
                  <a href="https://twitter.com/instacitiwow" target="_blank">
                    <img
                      src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/icons/twitter-icon.svg"
                      class=""
                      alt="facebook"
                    />
                  </a>
                </div>
                <div class="socialIcon me-3">
                  <a
                    href="https://www.linkedin.com/company/instacitiwow/"
                    target="_blank"
                  >
                    <img
                      src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/icons/linkedin-icon.svg"
                      alt="facebook"
                    />
                  </a>
                </div>
                <div class="socialIcon me-3">
                  <a
                    href="https://www.instagram.com/instacitiwow"
                    target="_blank"
                  >
                    <img
                      src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/icons/instagram-icon.svg"
                      alt="facebook"
                    />
                  </a>
                </div>
                <div class="socialIcon me-3">
                  <a
                    href="https://www.youtube.com/channel/UCczc_1IJkCkXAPCEyW4XhkQ"
                    target="_blank"
                  >
                    <img
                      src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/icons/youtube-icon.svg"
                      alt="facebook"
                    />
                  </a>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 mt-3">
                <p class="font16 font600 colorLightBlack">Download Apps</p>
                <div class="row">
                  <div class="col-12 bottom-google">
                    <div class="row">
                      <div class="col-6 pe-1">
                        <a href="https://play.google.com/store/apps/details?id=com.instaciti.Instaciti.instaciti&pli=1" target="_blank">
                          <img
                            src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/images/play-store.svg"
                            class="img-fluid"
                            alt="Google-play"
                          />
                        </a>
                      </div>
                      <div class="col-6 ps-1">
                        <a href="https://apps.apple.com/in/app/instaciti/id1552560571" target="_blank">
                          <img
                            src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/images/app-store.svg"
                            class="img-fluid"
                            alt="Google-play"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="false" class="col-lg-3 col-md-3 col-6 mt-4">
            <div class="row">
              <div class="col-lg-2 col-md-3 col-4">
                <img
                  src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/icons/company.svg"
                  alt="building-icon"
                />
              </div>
              <div class="col-lg-10 col-md-9 col-8 ps-0">
                <p class="font600 font16 customPurple">Company</p>
                <ul class="list-unstyled font-14 lightMuted textDecorationNone">
                  <li class="mt-1"><a href="#">Who We Are</a></li>
                  <li class="mt-1"><a href="#">Blog</a></li>
                  <li class="mt-1"><a href="#">Careers</a></li>
                  <li class="mt-1"><a href="#">Report Froud</a></li>
                  <li class="mt-1"><a href="#">Contact</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div *ngIf="false" class="col-lg-3 col-md-3 col-6 mt-4">
            <div class="row">
              <div class="col-lg-2 col-md-3 col-4">
                <img
                  src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/icons/help.svg"
                  alt="building-icon"
                />
              </div>
              <div class="col-lg-10 col-md-9 col-8">
                <p class="font600 font16 customPurple">Help</p>
                <ul class="list-unstyled font-14 lightMuted textDecorationNone">
                  <li class="mt-1"><a href="#">Help Center</a></li>
                  <li class="mt-1"><a href="#">How it works</a></li>
                  <li class="mt-1"><a href="#">FAQ</a></li>
                  <li class="mt-1"><a href="#">Video Tutorials</a></li>
                  <li class="mt-1"><a href="#">Business blog</a></li>
                  <li class="mt-1"><a href="#">Sitemap</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div *ngIf="false" class="col-lg-3 col-md-6 col-12 mt-4">
            <div class="row">
              <div class="col-2">
                <img
                  src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/icons/legal.svg"
                  alt="building-icon"
                />
              </div>
              <div class="col-10">
                <p class="font600 font16 customPurple">Legal</p>
                <ul class="list-unstyled font-14 lightMuted textDecorationNone">
                  <li class="mt-1"><a href="#">Privacy Policy</a></li>
                  <li class="mt-1">
                    <a href="#">Data Processing Agreement</a>
                  </li>
                  <li class="mt-1">
                    <a href="#">Job Application Privacy Policy</a>
                  </li>
                  <li class="mt-1"><a href="#">Cookie Policy</a></li>
                  <li class="mt-1"><a href="#">ISO 27001 Certification</a></li>
                  <li class="mt-1"><a href="#">GDPR Compliance</a></li>
                  <li class="mt-1"><a href="#">Terms and Conditions</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-md-6 mt-3 align-self-end text-end">
            <p class="mb-0 font12 lightMuted responsiveTextAlign">
              <span class="font20 align-middle">©</span>Copyright 2020.
              InstaCiti | All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
